// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__9iqt8"};